<template>
  <section class="demo-overview">
    <h2>ADMIN · 관리자 체험</h2>
    <p>화면의 모든 회원·금액·베팅 내역은 가상 데이터입니다.</p>
    <div class="demo-cards">
      <article v-for="card in cards" :key="card.label"><span>{{ card.label }}</span><strong>{{ card.value.toLocaleString() }}</strong></article>
    </div>
    <h3>최근 샘플 베팅</h3>
    <div class="demo-table"><table class="mainTable">
      <thead><tr><th>회원 아이디</th><th>게임</th><th>베팅금액</th><th>당첨금액</th><th>등록일시</th></tr></thead>
      <tbody><tr v-for="bet in recent" :key="bet.betId"><td><router-link :to="{ path: '/user/detail', query: { id: bet.memId } }">{{ bet.memId }}</router-link></td><td>{{ bet.gameName }}</td><td>{{ bet.betAmt.toLocaleString() }}</td><td>{{ bet.betWinAmt.toLocaleString() }}</td><td>{{ bet.regDate }}</td></tr></tbody>
    </table></div>
  </section>
</template>
<script>
import { totals, bets } from './api.cjs'
export default {
  name: 'DemoOverview',
  data () {
    return {
      recent: bets.slice(-8).reverse(),
      cards: [
        { label: '전체 회원', value: totals.memCnt }, { label: '접속 회원', value: totals.memLoginCnt },
        { label: '신규 가입', value: totals.memJoinCnt }, { label: '베팅 회원', value: totals.betMemCnt },
        { label: '회원 보유머니', value: totals.cashAmt }, { label: '회원 보유포인트', value: totals.pointAmt },
        { label: '금일 입금액', value: totals.inCashAmt }, { label: '금일 출금액', value: totals.outCashAmt },
        { label: '금일 베팅금액', value: totals.betAmt }, { label: '금일 당첨금액', value: totals.winAmt },
        { label: '금일 베팅손익', value: totals.beneAmt }, { label: '보유알', value: 10000000 }
      ]
    }
  }
}
</script>
<style scoped>
.demo-overview { padding: 30px 24px 70px; color: #edf3fa; }
h2 { font-size: 24px; margin-bottom: 14px; font-weight: 600; } h3 { margin: 30px 0 15px; font-size: 18px; font-weight: 600; }
p { margin: 10px 0; color: #c0cbd9; } .demo-cards { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; margin: 28px 0; }
article { background: #242e40; border: 1px solid #354154; border-radius: 8px; padding: 24px; } article span { display: block; margin-bottom: 12px; } article strong { font-size: clamp(18px, 4.5vw, 26px); font-weight: 600; color: #58d69d; overflow-wrap: anywhere; }
.demo-table { overflow-x: auto; } .demo-table table { min-width: 700px; }
td a { color: #82b9ff; } @media(max-width: 900px) { .demo-cards { grid-template-columns: repeat(2, 1fr); } }
</style>
